<template>
  <div class="video__wrap">
    <button v-if="videoShow" @click="toPlay" style="z-index: 2" type="button" aria-labelledby="video-451157723" class="c-lazy-frame__play-button">
    <span class="sr-only">在Vimeo开启视频</span>
    </button>
    <img v-if="videoShow" class="c-lazy-frame__image lazyloaded" :src="iSrc_m" />
    <video ref="video__element" :poster="iSrc_m" :src="vSrc" preload="auto"
      :loop="isLoop" :autoplay="isAuto" :muted="isMuted" :controls="showControls" controlslist="nodownload" disablePictureInPicture
      playsinline="true"
      webkit-playsinline="true"
      x5-playsinline="true"
      x5-video-orientation="landscape"
      x5-video-player-type="h5-page"
      x5-video-player-fullscreen="true"
    >
    </video>
  </div>
</template>

<script>
import utils from "@/utils";
export default {
  name: 'VideoWrap',
  props: {
    vSrc: { type: String, required: true },
    vSrc_m: { type: String, required: false },
    iSrc: { type: String, required: false },
    iSrc_m: { type: String, required: false },
    isLoop: { type: null, default: false, required: false },
    isAuto: { type: null, default: false, required: false },
    isMuted: { type: Boolean, default: true, required: false },
    showControls: { type: Boolean, default: false, required: false }
  },
  data() {
    return {
      vStatus: 0, // 1: 播放, 0: 停止
      videoShow: true
    };
  },
  mounted() {
    let vElement = this.$refs?.video__element;
    if (vElement) {
      vElement.addEventListener("play", this.vPlay);
      vElement.addEventListener("ended", this.vEnded);
      vElement.addEventListener("canplay", this.vTimeupdate);
      vElement.addEventListener("pause", this.vPause);
      this.isAuto && this.toPlay();
      // if(!this.i_src) {
      //   setTimeout(() => {
      //     this.videoShow = false
      //   }, 1500);
      // }
    }
  },
  computed: {
    isWX() {
      return utils.isWXBrowser();
    },
    isH5() {
      return utils.isMobile() || this.isWX;
    },
    v_src() {
      if (this.isH5 && this.vSrc_m) {
        return this.vSrc_m;
      }
      return this.vSrc;
    },
    i_src() {
      if (this.isH5 && this.iSrc_m && !/1.jpg$/.test(this.iSrc_m)) {
        return this.iSrc_m;
      } else if (this.iSrc && !/1.jpg$/i.test(this.iSrc)) {
        return this.iSrc;
      }
      return ''
    }
  },
  methods: {
    toPlay() {
      if (this.$refs?.video__element?.play) {
        this.$refs.video__element.play();
        this.videoShow = false
      }
    },
    toPuase() {
      if (this.$refs?.video__element?.pause) {
        this.$refs.video__element.pause();
      }
    },
    vPlay() {
      this.vStatus = 1;
      this.$emit('changePlay',{vSrc: this.vSrc})
    },
    vPause() {

    },
    vEnded() {
      this.vStatus = 0;
    },
    vTimeupdate() {
      // if(this.videoShow) this.videoShow = false
    },
    onImgLoaded() {
      this.videoShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.c-lazy-frame__play-button{width:3.75rem;height:2.5rem;background-color:#fff;border-radius:1.375rem;z-index:1;cursor:pointer;transition:all .2s linear}
.c-lazy-frame__play-button,.c-lazy-frame__play-button:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}
.c-lazy-frame__play-button:before{content:"";display:block;width:0;height:0;border-color:transparent transparent transparent #000;border-style:inset inset inset solid;border-width:7px 0 7px 7px}
.c-lazy-frame__play-button:hover{background-color:#000}
.c-lazy-frame__play-button:hover:before{border-left-color:#fff}
.c-lazy-frame__image{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;width:100%;z-index: 1;}
.c-lazy-frame__image_video{z-index: 0;}
video{
      position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    cursor: pointer;
    width: 100%;
    z-index: 0;
}
</style>